import * as t from "./actionTypes"
import { setterReducer } from "../common/redux"
import { combineReducers } from "redux"

const paid = setterReducer(false, t.SET_PAID)
const saved = setterReducer(null, t.SET_SAVED)
const integration = setterReducer(null, t.SET_INTEGRATION)
const reEntry = setterReducer({}, t.SET_REENTRY)
const timedOut = setterReducer(false, t.SET_TIMED_OUT)
const tipped = setterReducer(false, t.SET_TIPPED)
const tippingDisabled = setterReducer(false, t.SET_DISABLE_TIP)
const tipErrorMsg = setterReducer('', t.SET_TIP_ERROR_MSG)
const paymentErrorMsg = setterReducer('', t.SET_PAYMENT_ERROR_MSG)
const showTelemedicineModal = setterReducer(false, t.SHOW_TELEMEDICINE_MODAL)

const payment = combineReducers({
  paid,
  saved,
  integration,
  reEntry,
  timedOut,
  tipped,
  tippingDisabled,
  tipErrorMsg,
  paymentErrorMsg,
  showTelemedicineModal,
})

export { payment as default }



// WEBPACK FOOTER //
// ./assets/payment/reducer.js